export function SeatPlate({
	section,
	row,
	number,
}: {
	section: string;
	row: string;
	number: string | number;
}) {
	return (
		<h1 className="seat-plate">
			{section} {row}열 {number}번
		</h1>
	);
}
